module.exports = __webpack_public_path__ + "img/orders-empty.dd3b95ed.svg";